// extracted by mini-css-extract-plugin
module.exports = {"container":"MonthSelector_container__2PeEE","arrowButton":"MonthSelector_arrowButton__2nNwQ","icon":"MonthSelector_icon__3UCSy","monthDisplay":"MonthSelector_monthDisplay__12GS6"};